import React from "react";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../redux/user/user-selector';
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import TabComponent from "../../../../components/navbar-tab/navbar-tab";
import "./admin-tab-control.scss";

const AdminNavbar = ({ currentTab, setCurrentTab }) => {
    const user = useSelector(selectUser);
    const isSelfServe = window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";
    const isSuperAdmin = user.profile.isSuperAdminRole;
    const privileges = user?.privileges ?? {};
    const tabLabels=[];

    if (isSelfServe && !isSuperAdmin) {
        tabLabels.push("Users", "Role Privileges", "Notifications", "Templates", "Task Types");
    } else if (isSelfServe) {
        tabLabels.push("Users", "Groups", "Role Privileges", "Notifications", "Templates", "Task Types");
    } else {
        tabLabels.push("Users", "Groups", "Roles", "Role Privileges", "Organization", "Log Activity", "Notifications", "Templates", "Task Types");
    }

    if (isSuperAdmin || user.profile.isAdminRole) {
        if (privileges["Settings Editor"]?.View) {
            tabLabels.push("Settings Editor");
        }
        if (privileges["Workflow"]?.View) {
            tabLabels.push("Workflow");
        }
        if (privileges["Field Repository"]?.View) {
            tabLabels.push("Field Repository");
        }
    }

    const defaultTab = (tabLabels.length > 0) ? tabLabels[0] : ""; //When we have a reusable nav component this will be used to make sure passing an empty array won't break the app

    const getIconClassName = (label) => {
        switch(label){
            case "Users":
                return "tab-icon users-icon";
            case "Groups":
                return "tab-icon groups-icon";
            case "Roles":
                return "tab-icon roles-icon";
            case "Role Privileges":
                return "tab-icon role-privileges-icon";
            case "Organization":
                return "tab-icon department-icon";
            case "Log Activity":
                return "tab-icon log-activity-icon";
            case "Notifications":
                return "tab-icon email-config-icon";
            case "Templates":
                return "tab-icon project-templates-icon";
            case "Task Types":
                return "tab-icon task-types-icon";
            case "Settings Editor":
                    return "tab-icon settings-icon";
            case "Workflow":
                return "tab-icon workflow-icon";
            case "Field Repository":
                return "tab-icon workflow-icon";
            default:
                return "";
        }
    }

    return (
        <Navbar bg="light" expand="lg" className="admin-navbar tab-outer">
            <Navbar.Collapse className="nav-bar tab-container" style={{ width: "100%" }}>
                <Nav
                    style={{ width: "100%" }}
                    defaultActiveKey= {defaultTab}
                    activeKey={currentTab}
                    onSelect={selectedTab => setCurrentTab(selectedTab)}
                >
                        {
                            tabLabels.map( (labelName, index) => {
                                return(
                                    <TabComponent
                                        key = {index}
                                        label={labelName}
                                        icon = {getIconClassName(labelName)}
                                        active = {labelName === currentTab}
                                    />
                                );
                            })
                        }
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

AdminNavbar.propTypes = {
    currentTab: PropTypes.string.isRequired,
    setCurrentTab: PropTypes.func,
};

export default AdminNavbar;
